<div (click)="toggleExpansion()" class="header" [class.secondary]="variant() === 'secondary'">
  <span class="header-content"><ng-content select="dmb-expansion-panel-header"></ng-content></span>
  @if (effectiveShowIcon()) {
    <svg-icon icon="icon_arrow_down" />
  }
</div>
<div [style.maxHeight]="maxHeight()" class="contentContainer" [class.animation-running]="animationRunning()">
  <div #content><ng-content></ng-content></div>
</div>
